import WrapperEshops from './wrapper-eshop';

export default WrapperEshops;
